import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'marketplace-dialog.common.failure-status.heading',
		defaultMessage: 'We ran into a little trouble',
		description: 'The heading of the modal that shows the failed installation of a Marketplace app',
	},
	body: {
		id: 'marketplace-dialog.common.failure-status.body',
		defaultMessage: 'It might just be a hiccup. Try again in a bit.',
		description: 'The body of the modal that shows the failed installation of a Marketplace app',
	},
	tryAgainButtonLabel: {
		id: 'marketplace-dialog.common.failure-status.try-again-button-label',
		defaultMessage: 'Try again',
		description: 'The label of the button that will restart the failed installation',
	},
	cancelButtonLabel: {
		id: 'marketplace-dialog.common.failure-status.cancel-button-label',
		defaultMessage: 'Cancel',
		description: 'The label of the button that will close the modal without taking any action',
	},
});
